import dayjs from 'dayjs';
import { useQuery } from 'react-query';

import type { IUser } from 'src/api/users-api';
import {
    type IGetConversationsResponse,
    apiClient,
    Auth,
} from 'src/services/api';
import { useUpdateConversations } from 'src/services/push-notifications/use-update-conversations';

export const usePollConversations = (loggedInUser: IUser | undefined) => {
    const updateConversations = useUpdateConversations();

    const jwtPayload = Auth.jwtPayload;
    const isBypassPaywall = jwtPayload?.ibp;
    const isPaywallEnabled = !isBypassPaywall && !loggedInUser?.team?.is_active;

    return useQuery(
        ['poll-conversations', loggedInUser?.uuid, isPaywallEnabled ? 'paywall' : 'no-paywall'],
        async () => {
            const res = await apiClient('api/landlord/conversations', {
                searchParams: {
                    is_archived: false,
                    // This sends the correct datetime that is the user's local time converted to UTC
                    // Removing the timezone part, because backend cannot handle dates with timezones
                    since: dayjs().subtract(30, 'seconds').toISOString().split('Z')[0],
                }
            }).json<IGetConversationsResponse>();

            if (!res.conversations.length) {
                return;
            }

            updateConversations(res.conversations);
        }, {
            enabled: !!loggedInUser?.is_onboarding_complete && !isPaywallEnabled,
            refetchInterval: 15000,
        }
    );
};
